import { cn } from "@/ui/utils/cn";
import { ReactNode } from "react";

/**
 * A device frame drawn in CSS so the screen inside can be real, localized
 * markup instead of a screenshot. 9:19.5 aspect, ~300px wide by default.
 */
export const PhoneFrame = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "relative w-[290px] shrink-0 rounded-[2.75rem] border-[6px] border-ink bg-ink shadow-phone",
      className,
    )}
    aria-hidden="true"
  >
    <div className="absolute inset-x-0 top-2.5 z-10 mx-auto h-6 w-24 rounded-full bg-ink" />
    <div className="relative aspect-[9/19.2] overflow-hidden rounded-[2.4rem] bg-white">
      {children}
    </div>
  </div>
);
